import { useMutation, useQueryClient } from "@tanstack/react-query";
import { templateBuilderMutations } from "@/features/template-builder/mutations";
import { templateBuilderQueries } from "@/features/template-builder/queries";
import type {
  TemplateListItem,
  TemplateWithSettings,
} from "@/domains/templates/types";

type Params = {
  templateId: string;
  name?: string;
  context?: string | null;
};

export function useUpdateTemplateHeader() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ templateId, name, context }: Params) =>
      templateBuilderMutations.updateTemplateMetadata({
        templateId,
        ...(name !== undefined ? { name } : {}),
        ...(context !== undefined ? { description: context } : {}),
      }),
    onSuccess: (canonicalTemplate) => {
      if (!canonicalTemplate.analysis_id) return;
      queryClient.setQueryData<TemplateWithSettings>(
        templateBuilderQueries.detail(canonicalTemplate.analysis_id).queryKey,
        canonicalTemplate,
      );
      queryClient.setQueriesData<TemplateListItem[]>(
        { queryKey: templateBuilderQueries.lists().queryKey },
        (current) =>
          current?.map((item) =>
            item.template.analysis_id === canonicalTemplate.analysis_id
              ? { ...item, template: canonicalTemplate }
              : item,
          ),
      );
    },
  });
}
